<template>
  <section class="blood-collection-section">
    <h2>ขั้นตอนการ<strong>เก็บเลือด</strong></h2>
    <p>
      ใช้เวลาประมาณ 10-15 นาที โดยคุณหมอจะคำนวนปริมาณเลือดที่เก็บได้จากน้ำหนักตัว เพื่อไม่ให้เป็นอันตรายต่อสัตว์เลี้ยง
    </p>
    <container>
      <div class="col donation-step-container">
        <div class="donation-step">
          <img src="@/assets/donation-info/blood-collection-1.png" alt="blood donation step">
          <span class="number">วิธีที่ 1</span>
          <span class="content">เจาะเลือดจากเส้นเลือดใหญ่ที่คอ</span>
        </div>
        <div class="donation-step">
          <img src="@/assets/donation-info/blood-collection-2.png" alt="blood donation step">
          <span class="number">วิธีที่ 2</span>
          <span class="content">เจาะเลือดจากขาหน้า</span>
        </div>
      </div>
    </container>
  </section>
</template>

<script>
import Container from '@/components/Container.vue'

export default {
  name: 'BloodCollectionSection',
  components: {
    Container
  }
}
</script>

<style scoped lang="scss">
.blood-collection-section {
  background-color: $gray-100;
  padding: 2rem 0;
  h2 {
    text-align: center;
    font-size: $h3-font-size;
    font-weight: $font-weight-light;
    strong {
      font-weight: $font-weight-normal;
    }
  }
  p {
    margin: 1rem;
    color: $gray-500;
    font-weight: $font-weight-light;
    font-family: $font-family-thai;
    text-align: center;
  }
}
@media (min-width: map-get($grid-breakpoints, "sm")) {
  .blood-collection-section {
    h2 {
      font-size: $h1-font-size;
    }
  }
}
</style>
